// import React, { useEffect, useState } from "react";
// import Layout, { Container } from "../components/layout";
// import { ChevronRight, Filter, CheckCircle, X } from "lucide-react";
// import { apiurl } from "../config/config";
// import axios from "axios";

// const PaymentsPage = () => {
//   const [payments, setPayments] = useState([]);
//   const [skip, setSkip] = useState(0);
//   const [count] = useState(100);
//   const [loading, setLoading] = useState(false);
//   const [selected, setSelected] = useState(null);

//   const getTodayStart = () => {
//     const now = new Date();
//     now.setHours(0, 0, 0, 0);
//     return Math.floor(now.getTime() / 1000);
//   };

//   const getTodayEnd = () => {
//     const now = new Date();
//     now.setHours(23, 59, 59, 999);
//     return Math.floor(now.getTime() / 1000);
//   }

//   const [filters, setFilters] = useState({
//     status: "",
//     method: "",
//   });

//   /* ---------------- FETCH PAYMENTS ---------------- */
//   const fetchPayments = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(`${apiurl}/services/razorpay/payments`, {
//         params: {
//           from: getTodayStart(),
//           to: getTodayEnd(),
//           skip,
//           count,
//           ...filters,
//         },
//       });

//       setPayments(res.data.items || []);
//     } catch (err) {
//       console.error("Payment fetch error", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPayments();
//   }, [skip, filters]);

//   /* ---------------- UI ---------------- */
//   return (
//     <Layout>
//       <Container overflow={"overflow-scroll"}>
//         <div className="p-6 bg-gray-50 min-h-screen space-y-6">

//           {/* ================= HEADER + FILTERS ================= */}
//           <div className="bg-white rounded-xl shadow p-4 flex flex-wrap gap-4 items-center justify-between">
//             <h2 className="text-lg font-semibold">Today’s Razorpay Payments</h2>

//             <div className="flex gap-3 items-center">
//               <select
//                 className="border rounded-lg px-3 py-2 text-sm"
//                 value={filters.status}
//                 onChange={(e) =>
//                   setFilters({ ...filters, status: e.target.value })
//                 }
//               >
//                 <option value="">All Status</option>
//                 <option value="captured">Captured</option>
//                 <option value="failed">Failed</option>
//               </select>

//               <select
//                 className="border rounded-lg px-3 py-2 text-sm"
//                 value={filters.method}
//                 onChange={(e) =>
//                   setFilters({ ...filters, method: e.target.value })
//                 }
//               >
//                 <option value="">All Methods</option>
//                 <option value="upi">UPI</option>
//                 <option value="card">Card</option>
//                 <option value="netbanking">Net Banking</option>
//               </select>

//               <button
//                 onClick={() => setSkip(0)}
//                 className="flex items-center gap-1 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm"
//               >
//                 <Filter size={14} />
//                 Apply
//               </button>
//             </div>
//           </div>

//           {/* ================= PAYMENTS TABLE ================= */}
//           <div className="bg-white rounded-xl shadow overflow-hidden">
//             <table className="w-full text-sm">
//               <thead className="bg-gray-100 text-left">
//                 <tr>
//                   <th className="p-3">Payment ID</th>
//                   <th>RRN</th>
//                   <th>Amount</th>
//                   <th>Status</th>
//                   <th>RRN Verified</th>
//                   <th>HRMS Match</th>
//                   <th></th>
//                 </tr>
//               </thead>

//               <tbody>
//                 {loading ? (
//                   <tr>
//                     <td colSpan="7" className="p-4 text-center">
//                       Loading payments...
//                     </td>
//                   </tr>
//                 ) : payments.length === 0 ? (
//                   <tr>
//                     <td colSpan="7" className="p-4 text-center text-gray-500">
//                       No payments found
//                     </td>
//                   </tr>
//                 ) : (
//                   payments.map((p) => (
//                     <tr
//                       key={p.id}
//                       className="border-t hover:bg-gray-50 cursor-pointer"
//                       onClick={() => setSelected(p)}
//                     >
//                       <td className="p-3 font-mono">{p.id}</td>
//                       <td>{p.acquirer_data?.rrn || "-"}</td>
//                       <td>₹{p.amount / 100}</td>
//                       <td className="capitalize">{p.status}</td>

//                       {/* RRN Flag */}
//                       <td>
//                         {p.acquirer_data?.rrn ? (
//                           <CheckCircle className="w-4 h-4 text-green-500" />
//                         ) : (
//                           "-"
//                         )}
//                       </td>

//                       {/* HRMS Match (future logic) */}
//                       <td className="text-gray-400">Pending</td>

//                       <td>
//                         <ChevronRight size={16} />
//                       </td>
//                     </tr>
//                   ))
//                 )}
//               </tbody>
//             </table>
//           </div>

//           {/* ================= PAGINATION ================= */}
//           <div className="flex justify-between items-center">
//             <button
//               disabled={skip === 0}
//               onClick={() => setSkip(skip - count)}
//               className="px-4 py-2 border rounded-lg disabled:opacity-40"
//             >
//               Previous
//             </button>

//             <button
//               onClick={() => setSkip(skip + count)}
//               className="px-4 py-2 border rounded-lg"
//             >
//               Next
//             </button>
//           </div>

//           {/* ================= SLIDE DRAWER ================= */}
//           {selected && (
//             <div className="fixed inset-0 bg-black/30 flex justify-end z-50">
//               <div className="w-full max-w-md bg-white h-full shadow-xl p-6 overflow-y-auto">
//                 <div className="flex justify-between items-center mb-4">
//                   <h3 className="text-lg font-semibold">Payment Details</h3>
//                   <X
//                     className="cursor-pointer"
//                     onClick={() => setSelected(null)}
//                   />
//                 </div>

//                 <div className="space-y-3 text-sm">
//                   <p><b>ID:</b> {selected.id}</p>
//                   <p><b>Status:</b> {selected.status}</p>
//                   <p><b>Amount:</b> ₹{selected.amount / 100}</p>
//                   <p><b>Method:</b> {selected.method}</p>
//                   <p><b>RRN:</b> {selected.acquirer_data?.rrn || "-"}</p>
//                   <p><b>Email:</b> {selected.email || "-"}</p>
//                   <p><b>Contact:</b> {selected.contact || "-"}</p>
//                   <p><b>Created:</b> {new Date(selected.created_at * 1000).toLocaleString()}</p>
//                 </div>
//               </div>
//             </div>
//           )}

//         </div>
//       </Container>
//     </Layout>
//   );
// };

// export default PaymentsPage;
import React, { useEffect, useState } from "react";
import Layout, { Container } from "../components/layout";
import { ChevronRight, Filter, CheckCircle, X, Search } from "lucide-react";
import axios from "axios";
import { apiurl } from "../config/config";

const PaymentsPage = () => {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [skip, setSkip] = useState(0);
  const [count] = useState(100);

  const getUnixFromDate = (dateString, endOfDay = false) => {
  const date = new Date(dateString);
  if (endOfDay) {
    // Set time to 23:59:59 UTC
    date.setUTCHours(23, 59, 59, 999);
  } else {
    // Set time to 00:00:00 UTC
    date.setUTCHours(0, 0, 0, 0);
  }
  return Math.floor(date.getTime() / 1000);
};



  const [filters, setFilters] = useState({
    status: "",
    method: "",
    orderId: "",
    search: "",
    from: new Date(new Date().setHours(0, 0, 0, 0)).toISOString().slice(0, 10),
    to: new Date(new Date().setHours(23, 59, 59, 999)).toISOString().slice(0, 10),
  });

  const fetchPayments = async () => {
    try {
      setLoading(true);

      const res = await axios.get(`${apiurl}/services/razorpay/payments`, {
        params: {
        //   from: Math.floor(new Date(filters.from).getTime() / 1000),
        //   to: Math.floor(new Date(filters.to).getTime() / 1000),
            from: getUnixFromDate(filters.from),
    to: getUnixFromDate(filters.to, true),
          skip,
          count,
        },
      });

      let items = res.data.items || [];

      // ---------------- APPLY FILTERS ----------------
      if (filters.status) items = items.filter(p => p.status === filters.status);
      if (filters.method) items = items.filter(p => p.method === filters.method);
      if (filters.orderId === "has") items = items.filter(p => p.order_id);
      if (filters.orderId === "none") items = items.filter(p => !p.order_id);
      if (filters.search)
        items = items.filter(p =>
          p.id.includes(filters.search) ||
          p.acquirer_data?.rrn?.includes(filters.search) ||
          p.order_id?.includes(filters.search)
        );

      setPayments(items);
    } catch (err) {
      console.error("Payment fetch error", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, [skip, filters]);

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="p-6 bg-gray-50 min-h-screen space-y-6">

          {/* =============== HEADER & FILTERS ================= */}
          <div className="bg-white rounded-xl shadow p-4 flex flex-wrap gap-4 items-center justify-between">
            <h2 className="text-lg font-semibold">Razorpay Payments Dashboard</h2>

            <div className="flex flex-wrap gap-3 items-center">

              {/* Status Filter */}
              <select
                className="border rounded-lg px-3 py-2 text-sm"
                value={filters.status}
                onChange={e => setFilters({ ...filters, status: e.target.value })}
              >
                <option value="">All Status</option>
                <option value="captured">Captured</option>
                <option value="failed">Failed</option>
              </select>

              {/* Method Filter */}
              <select
                className="border rounded-lg px-3 py-2 text-sm"
                value={filters.method}
                onChange={e => setFilters({ ...filters, method: e.target.value })}
              >
                <option value="">All Methods</option>
                <option value="upi">UPI</option>
                <option value="card">Card</option>
                <option value="netbanking">Net Banking</option>
              </select>

              {/* Order ID Filter */}
              <select
                className="border rounded-lg px-3 py-2 text-sm"
                value={filters.orderId}
                onChange={e => setFilters({ ...filters, orderId: e.target.value })}
              >
                <option value="">All Orders</option>
                <option value="has">Has Order ID</option>
                <option value="none">No Order ID</option>
              </select>

              {/* Date Range */}
              <input
                type="date"
                className="border rounded-lg px-3 py-2 text-sm"
                value={filters.from}
                onChange={e => setFilters({ ...filters, from: e.target.value })}
              />
              <input
                type="date"
                className="border rounded-lg px-3 py-2 text-sm"
                value={filters.to}
                onChange={e => setFilters({ ...filters, to: e.target.value })}
              />

              {/* Search */}
              <div className="relative">
                <input
                  type="text"
                  placeholder="Search by Payment ID / RRN / Order ID"
                  className="border rounded-lg px-10 py-2 text-sm"
                  value={filters.search}
                  onChange={e => setFilters({ ...filters, search: e.target.value })}
                />
                <Search className="absolute left-3 top-2.5 w-5 h-5 text-gray-400" />
              </div>

              {/* Apply Button */}
              <button
                onClick={() => setSkip(0)}
                className="flex items-center gap-1 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm"
              >
                <Filter size={14} />
                Apply
              </button>

            </div>
          </div>

          {/* ================= PAYMENTS TABLE ================= */}
          <div className="bg-white rounded-xl shadow overflow-x-auto">
            <table className="w-full text-sm min-w-[800px]">
              <thead className="bg-gray-100 text-left">
                <tr>
                  <th className="p-3">Payment ID</th>
                  <th>RRN</th>
                  <th>Amount</th>
                  <th>Status</th>
                  <th>RRN Verified</th>
                  <th>HRMS Match</th>
                  <th>Order ID</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="8" className="p-4 text-center">Loading payments...</td>
                  </tr>
                ) : payments.length === 0 ? (
                  <tr>
                    <td colSpan="8" className="p-4 text-center text-gray-500">No payments found</td>
                  </tr>
                ) : (
                  payments.map(p => (
                    <tr
                      key={p.id}
                      className="border-t hover:bg-gray-50 cursor-pointer"
                      onClick={() => setSelected(p)}
                    >
                      <td className="p-3 font-mono">{p.id}</td>
                      <td>{p.acquirer_data?.rrn || "-"}</td>
                      <td>₹{p.amount / 100}</td>
                      <td className="capitalize">{p.status}</td>

                      {/* RRN Verification */}
                      <td>{p.acquirer_data?.rrn ? <CheckCircle className="w-4 h-4 text-green-500"/> : "-"}</td>

                      {/* HRMS Placeholder */}
                      <td className="text-gray-400">{p.order_id ? "Matched" : "Pending"}</td>

                      {/* Order ID */}
                      <td>{p.order_id || "-"}</td>

                      <td><ChevronRight size={16}/></td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* ================= PAGINATION ================= */}
          <div className="flex justify-between items-center mt-4">
            <button
              disabled={skip === 0}
              onClick={() => setSkip(Math.max(skip - count, 0))}
              className="px-4 py-2 border rounded-lg disabled:opacity-40"
            >
              Previous
            </button>

            <button
              onClick={() => setSkip(skip + count)}
              className="px-4 py-2 border rounded-lg"
            >
              Next
            </button>
          </div>

          {/* ================= SLIDE DRAWER ================= */}
          {selected && (
            <div className="fixed inset-0 bg-black/30 flex justify-end z-50">
              <div className="w-full max-w-md bg-white h-full shadow-xl p-6 overflow-y-auto">
                <div className="flex justify-between items-center mb-4">
                  <h3 className="text-lg font-semibold">Payment Details</h3>
                  <X className="cursor-pointer" onClick={() => setSelected(null)} />
                </div>

                <div className="space-y-3 text-sm">
                  <p><b>ID:</b> {selected.id}</p>
                  <p><b>Status:</b> {selected.status}</p>
                  <p><b>Amount:</b> ₹{selected.amount / 100}</p>
                  <p><b>Method:</b> {selected.method}</p>
                  <p><b>RRN:</b> {selected.acquirer_data?.rrn || "-"}</p>
                  <p><b>Email:</b> {selected.email || "-"}</p>
                  <p><b>Contact:</b> {selected.contact || "-"}</p>
                  <p><b>Order ID:</b> {selected.order_id || "-"}</p>
                  <p><b>Notes:</b> {selected.notes ? JSON.stringify(selected.notes) : "-"}</p>
                  <p><b>Created:</b> {new Date(selected.created_at * 1000).toLocaleString()}</p>
                </div>
              </div>
            </div>
          )}

        </div>
      </Container>
    </Layout>
  );
};

export default PaymentsPage;